import React from 'react';
import PropTypes from 'prop-types';
import { TurbineStatusChartBase } from './TurbineStatusChart.styles';

import { TimelineCollapsibleChart } from '../Timeline/TimelineCollapsibleChart';
import { TurbineStatusChartRowHeader } from './TurbineStatusChartRowHeader';

import { WithScroller } from '../Scroller/WithScroller';
import { useRematchSelector } from 'models/rematchStore';

const mergeAllListData = ({ notes, exceptions, restrictions, statuses }) => {
    if (!notes && !exceptions && !restrictions && !statuses) {
        return null;
    }

    return [].concat(notes, exceptions, restrictions, statuses).filter((v) => v);
};

export const TurbineStatusChart = ({ chartWidth }) => {
    const turbineStatusChart = useRematchSelector((state) => state.turbineStatusChart);
    const timelineData = mergeAllListData(turbineStatusChart);
    const headerWidth = 500;
    const chartMinWidth = 1000;
    const chartMaxWidth = 2000;
    const useScroller = chartWidth <= chartMinWidth;
    const childChartWidth = useScroller ? chartMaxWidth : chartWidth;

    return (
        <TurbineStatusChartBase data-testid="turbine-status-chart">
            <WithScroller useScroller={useScroller}>
                {() => (
                    <>
                        <TurbineStatusChartRowHeader width={headerWidth} chartWidth={childChartWidth} />
                        <TimelineCollapsibleChart
                            chartWidth={childChartWidth}
                            timelineData={timelineData}
                            itemLabelWidth={headerWidth}
                        />
                    </>
                )}
            </WithScroller>
        </TurbineStatusChartBase>
    );
};

TurbineStatusChart.displayName = 'TurbineStatusChart';

TurbineStatusChart.propTypes = {
    chartWidth: PropTypes.number,
};

TurbineStatusChart.defaultProps = {};
